<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="19">
            <div class="form_item">
              <a-form-model-item :label-col="{ span: 9 }" label="活动类型">
                <a-select v-model="countData.HDTYPE" style="width: 300px" :disabled="disabledAll">
                  <a-select-option :value="item.value" v-for="item of HDTypeOptions" :key="item.planCode">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item :label-col="{ span: 9 }" label="保险期限">
                <a-radio-group :disabled="disabledAll" v-model="countData.BXQX" @change="e => changeData(e.target.value, 'BXQX')">
                  <a-radio :value="item.value" v-for="item of BXQXOptions" :key="item.value">
                    {{ item.name }}
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item ref="YYMJ" :prop="!disabledAll ? 'YYMJ' : ''" :label-col="{ span: 9 }" label="营业面积">
                <a-select placeholder="请选择营业面积（平米）" :disabled="disabledAll" style="width: 280px" :value="countData.YYMJ" class="select_" @change="value => changeData(value, 'YYMJ')">
                  <a-select-option v-for="item in YYMJOptios" :key="item.value + 'YYMJ'" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item ref="TBRC" :prop="!disabledAll ? 'TBRC' : ''" :label-col="{ span: 9 }" label="投保人次" v-if="countData.HDTYPE == 'PAHDLGZYanChu'">
                <a-input-number :disabled="disabledAll" :min="0" :max="20000" style="width: 280px" v-model="countData.TBRC" @change="e => changeData(e.target.value, 'TBRC')" placeholder="请填写投保人次"></a-input-number>
              </a-form-model-item>
            </div>
            <p class="p-header">主险</p>
            <!-- 公众责任险保额（累计赔偿限额） -->
            <div class="form_item">
              <a-form-model-item ref="GZZR" :prop="!disabledAll ? 'GZZR' : ''" :label-col="{ span: 9 }" label="公众责任险保额（累计赔偿限额）">
                <a-select placeholder="请填写保额" :disabled="disabledAll" style="width: 280px" :value="countData.GZZR" class="select_" @change="value => changeData(value, 'GZZR')">
                  <a-select-option v-for="item in GZZROptios" :key="item.value + 'GZZR'" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="btn_list">
              <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
              <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </div>
</template>

<script>
import moment from 'moment';
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      allData: {},
      premiumSum: 0, //总保费
      planOffsetDay: 0,
      // 测算要提交的数据
      countData: {
        HDTYPE: undefined, //活动类型
        BXQX: undefined, //保险期限
        TBRC: undefined, //投保人数
        YYMJ: undefined, //营业面积
        HDLX: undefined, //活动类型
        GZZR: undefined, //公众责任险保额（累计赔偿限额）
      },
      // 校验规则
      rules: {
        YYMJ: [{ required: true, message: '请选择营业面积', trigger: 'blur' }],
        GZZR: [{ required: true, message: '请填写公众责任', trigger: 'blur' }],
        TBRC: [{ required: true, message: '请填写投保人次', trigger: 'blur' }],
        BXQX: [{ required: true, message: '请选择保险期限', trigger: 'blur' }],
        HDLX: [{ required: true, message: '请选择活动类型', trigger: 'blur' }],
      },
      //提交data
      data: {},
      planType: 'A',
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      HDTypeOptions: [
        //活动类型选项
        {
          name: '展会/展示活动、商场周边活动、发布会',
          value: 'PAHDLGZ_1',
        },
        {
          name: '其他短期非体育活动',
          value: 'PAHDLGZ_2',
        },
        {
          name: '体育活动',
          value: 'PAHDLGZ_3',
        },
        // {
        //   name:'演出/演唱会',
        //   value:'PAHDLGZYanChu',
        // },{
        //   name:'群众活动',
        //   value:'PAHDLGZQunZhong',
        // }
      ],
      BXQXOptions: [
        {
          name: '1天',
          value: '1',
        },
        {
          name: '2-7天',
          value: '7',
        },
        {
          name: '8-30天',
          value: '30',
        },
        {
          name: '三个月内',
          value: '90',
        },
      ],
      YYMJOptios: [
        {
          name: '300平米以内',
          value: '300',
        },
        {
          name: '300-1000平米',
          value: '1000',
        },
        {
          name: '1000-5000平米',
          value: '5000',
        },
      ],
      GZZROptios: [
        {
          name: '100万',
          value: '1000000',
        },
        {
          name: '200万',
          value: '2000000',
        },
        {
          name: '300万',
          value: '3000000',
        },
        {
          name: '500万',
          value: '5000000',
        },
        {
          name: '1000万',
          value: '10000000',
        },
      ],
    };
  },
  computed: {
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: 'GZZR',
          amount: this.countData.GZZR, //公众责任险保额（累计赔偿限额）
        },
      ];
      return infos;
    },
  },
  watch: {
    'countData.TBRC'(val) {
      if (val > 20000) {
        this.countData.TBRC = 0;
        this.$message.warning('投保人次不能超过2万');
      }
    },
  },
  props: ['disabledAll'],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.countData.HDTYPE = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  methods: {
    moment,
    busOnDataMethod() {
      let data = this.$lodash.cloneDeep(this.$parent.$refs.policyInfo.submitdata);
      console.log(data, '接收到的数据');
      this.$nextTick(() => {
        this.countData.YYMJ = data.salPolicyHolder.area;
        this.countData.BXQX = data.salPolicy.bracket;
        this.countData.TBRC = data.salPolicy.pieces;
        this.countData.HDLX = data.salPolicy.areaType;
        this.premiumSum = data.salPolicy.totalPremium;
        data.riskInfos.forEach(e => {
          this.countData[e.riskCode] = e.amount ? e.amount.toString() : 0;
        });
      });
    },
    // 去投保
    goplicy() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          this.$message.error('请填写完整数据在投保');
        } else {
          this.$store.commit('setAgreement', true);
        }
      });
    },
    //跳转路由的方法
    goPagePlan() {
      this.$router.push({
        name: 'pahdgz',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          policyId: this.policyId,
          planCode: this.countData.HDTYPE,
        },
      });
    },
    // 改变试算的数据
    changeData(value, param) {
      console.log(value, param);
      if (param == 'HDTYPE') {
        this.goPagePlan(value);
      }
      // if (!value || !param) return;
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount > 0),
        salPolicy: {
          planCode: this.countData.HDTYPE,
          creator: this.creator,
          productCode: this.productCode, //产品code
          pieces: this.countData.TBRC, //投保人次
          bracket: this.countData.BXQX, //保费期限
          areaType: this.countData.HDLX, //群众活动类型
        },
        salPolicyExt: {
          isworkheightinvolved: '2',
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          stature: '2', //是否高空（2-否，1-是）
          area: this.countData.YYMJ, //营业面积
          companytype: '99', //营业性质
        },
      };
      console.log(this.countData);
      let arrData = this.$lodash.cloneDeep(this.data);
      // console.log(arrData, "传过来的数据");
      this.allData = { ...arrData };
      this.$nextTick(() => {
        this.$parent.$refs.policyInfo.busDataMethod();
      });
    },
    //保费试算
    countPremiumSum() {
      this.changeData();
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.log(this.allData, '改变试算要提交的数据');
          this.$api.calPremiumEmployer(this.allData).then(res => {
            if (res.data.success) {
              if (res.data.content && res.data.content > 0) {
                this.premiumSum = res.data.content;
              }
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: -10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: -10px;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: '公众责任累计赔偿限额不能小于50万且不能超过3000万！';
  position: absolute;
  color: #fe8f2d;
  top: 14px;
  right: -300px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
</style>